"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeyboardModifier = void 0;
var KeyboardModifier;
(function (KeyboardModifier) {
    KeyboardModifier["Shift"] = "Shift";
    KeyboardModifier["Ctrl"] = "Control";
    KeyboardModifier["Meta"] = "Meta";
})(KeyboardModifier || (exports.KeyboardModifier = KeyboardModifier = {}));
